import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-set-moments',
  templateUrl: './set-moments.component.html',
  styleUrls: ['./set-moments.component.sass']
})
export class SetMomentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
